import { getDocs, Timestamp } from 'firebase/firestore'
import type { DocumentData, DocumentReference } from 'firebase/firestore'
import { defineStore } from 'pinia'
import type { Ref } from 'vue'
import { ref } from 'vue'
import { getDeliverLocation } from '~/firestoreWrappers/deliversLocation'
import { mapDeliversLocation } from '~/models/DeliversLocationModel'
import type { DeliversLocationModel } from '~/models/DeliversLocationModel'

export const useDeliversLocationStore = defineStore('deliversLocation', () => {
  const deliversLocations: Ref<DeliversLocationModel[]> = ref([])
  const fetchLoading: Ref<boolean> = ref(false)
  const fetchError: Ref<null | unknown> = ref(null)

  function getLocations(deliver: DocumentReference, company: DocumentReference, date: Date) {
    fetchLoading.value = true
    fetchError.value = null

    const onError = (error: unknown) => {
      fetchLoading.value = false
      fetchError.value = error
    }

    const onSuccess = (arg0: DocumentData) => {
      fetchLoading.value = false
      deliversLocations.value = arg0.docs.map(mapDeliversLocation)
    }

    getDocs(
      getDeliverLocation(deliver, company, Timestamp.fromDate(new Date(date.setHours(0, 0, 0, 0))), Timestamp.fromDate(new Date(date.setHours(23, 59, 59, 999)))),
    )
      .then(onSuccess)
      .catch(onError)
  }

  function resetState() {
    deliversLocations.value = []
    fetchLoading.value = false
    fetchError.value = null
  }

  return {
    deliversLocations,
    fetchLoading,
    fetchError,
    resetState,
    getLocations,
  }
})
